import styled from 'styled-components';
import { BodyText, FlexRow, Grid } from 'ui-toolkit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const StyledDivLine = styled.div`
  border-left: 1px solid ${(props) => props.theme.colors.gray300};
  height: 69px;
`;

export const StyledFlexRow = styled(FlexRow)`
  & > * {
    margin-left: unset;
  }
`;

export const StyledBodyText = styled(BodyText)`
  margin-left: unset;
  line-height: 15px;
`;

export const DottedLine = styled.div`
  border-top: 2px dashed ${(props) => props.theme.colors.gray};
`;

export const StyledInfo = styled.div`
  padding-right: 20px;
`;
export const StyledDocumentIcon = styled(FontAwesomeIcon)`
  color: ${(props) => props.theme.colors.secondaryDark};
  cursor: pointer;
`;
export const StyledPayeeIcon = styled(FontAwesomeIcon)`
  color: ${(props) => props.theme.colors.blue100};
  height: 28px;
  width: 30px;
`;
export const StyledIconNumber = styled.span`
  color: ${(props) => props.theme.colors.blueDark};
  padding-left: 7px;
`;

export const StyledGrid = styled(Grid)`
  align-items: flex-end;
  width: 100%;
`;
